import React from 'react';

import { BaseModal, ToastMessage } from '@cokitchen/cokitchen-components';
import { ResetPassword } from '@cokitchen/cokitchen-auth';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import useRoleContext from 'contexts/role.context';
import { toast } from 'react-toastify';
import { LoginEnvType } from '@cokitchen/cokitchen-auth/dist/lib/login/types';

type ResetPasswordProps = {
  show: boolean;
  onClose: () => void;
};
const authEnvironment = process.env.REACT_APP_AUTH_ENVIRONMENT as LoginEnvType;

const ResetPasswordModal = ({ show, onClose }: ResetPasswordProps) => {
  const token: any = localStorage.getItem(STORAGE_KEYS.TOKEN);
  const { setRole, setIsMainAdmin } = useRoleContext();
  const navigate = useNavigate();

  const logout = () => {
    toast(<ToastMessage type='success' message='Reset link sent to your email' />);
    localStorage.clear();
    setRole();
    setIsMainAdmin(false);
    navigate(ROUTE_KEYS.LOGIN);
  };
  return (
    <BaseModal
      position='right'
      isOpen={show}
      onRequestClose={onClose}
      title={
        <ResetPassword
          env={authEnvironment}
          token={token}
          onSuccess={logout}
          successCta='Go to Login'
          isAuthenticated
          title='Create New Password'
          description='Ensure password is different from previous used passwords'
          buttonText='Confirm Password'
        />
      }></BaseModal>
  );
};

export default ResetPasswordModal;
